<template>
  <div class="home">
    <div class="home-title">
      <div class="logo" style="color: #fff;font-size: 30px">
<!--        <img src="../../assets/img/logo.png" alt="" />-->
        重庆云锦荣科技有限公司
      </div>
      <nav>
        <a
          href="#introduce"
          @click.prevent="navChange(1)"
          :class="idx == 1 ? 'active' : ''"
          >首页</a
        >
        <a href="#product" @click.prevent="navChange(2)" :class="idx == 2 ? 'active' : ''"
          >产品矩阵</a
        >
        <a href="#case" @click.prevent="navChange(3)" :class="idx == 3 ? 'active' : ''"
          >案例介绍</a
        >
        <router-link to="about_p">关于我们</router-link>
      </nav>
    </div>
    <div class="banner" id="introduce">
      <div class="banner-item">
        <el-carousel :interval="5000" arrow="never" height="30rem">
          <el-carousel-item>
            <div class="banner-text">
              <div>连接一切可能</div>
              <div>欢迎来到云锦荣 给与您的帮助,是我们最大的荣幸</div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="banner-text">
              <div>云锦荣</div>
              <div>欢迎来到云锦荣 给与您的帮助,是我们最大的荣幸</div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <img src="../../assets/img/banner.png" alt="" class="banner-bg" />
    </div>
    <!-- 公司介绍 -->
    <div class="introduce">
      <div class="introduce-title">公司介绍</div>
      <div class="introduce-content">
        <img src="../../assets/img/introduce.png" alt="" />
        <div class="introduce-text">
          <div>重庆云锦荣科技有限公司</div>
          <div>
            提供“互联网+”整体解决方案，集互联网产品研发、自媒体运营、文化传播、运营推广、商品销售、管理咨询为一体的互联网科技公司。总部位于重庆市，目前拥有员工80余人，拥有丰富的行业经验、客户案例和整合资源。
          </div>
          <div>拥有独立运营推广团队的微信平台服务商。</div>
        </div>
      </div>
    </div>
    <!-- 产品区 -->
    <div class="product" id="product">
      <div class="product-title">产品矩阵</div>
      <div class="product-content">
        <div class="product-item">
          <div class="product-item-index">
            <img src="../../assets/img/product-1.png" alt="" />
            <div class="product-item-text">互联网+政务</div>
            <div class="product-item-tags">
              <span>重庆交巡警</span>
              <span>暖青汇</span>
              <span>愉快办</span>
            </div>
          </div>
          <div class="product-item-index">
            <img src="../../assets/img/product-1.png" alt="" />
            <div class="product-item-text">互联网+餐饮</div>
            <div class="product-item-tags">
              <span>重庆交巡警</span>
            </div>
          </div>
        </div>
        <div class="product-item2">
          <div class="product-item-index">
            <img src="../../assets/img/product-1.png" alt="" />
            <div class="product-item-text">互联网+车后</div>
            <div class="product-item-tags">
              <span>微务通</span>
            </div>
          </div>
          <div class="product-item-index">
            <img src="../../assets/img/product-1.png" alt="" />
            <div class="product-item-text">互联网+旅游</div>
            <div class="product-item-tags">
              <span>村游村购</span>
            </div>
          </div>
          <div class="product-item-index">
            <img src="../../assets/img/product-1.png" alt="" />
            <div class="product-item-text">互联网+农业</div>
            <div class="product-item-tags">
              <span>村务宝</span>
              <span>农展购</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 案例介绍 -->
    <div class="case" id="case">
      <div class="case-title">案例介绍</div>
      <div class="case-list">
        <div class="case-li">
          <img src="../../assets/img/case-1.png" alt="" />
          <div>
            <p>
              “采用灵活的市场机制，引入社会力量和社会资本投入，适当开发数据增值服务功能，用市场收入反哺系统运行”——《汽车维修电子健康档案系统建设指南》
              微务通SaaS平台——汽车服务大数据平台，针对各类客户痛点提供完整解决方案
            </p>
            <span>微务通</span>
          </div>
        </div>
        <div class="case-li">
          <img src="../../assets/img/case-2.png" alt="" />
          <div>
            <p>
              “暖青汇”志愿服务App是重庆首个面向志愿服务的在线移动综合服务平台。由共青团重庆市委为满足广大青年志愿需求和社交需要所打造的集专业性、互动性、开放性、便捷性于一体，涵盖志愿者线上注册、服务供需对接、服务时长记录等一站式服务。注册用户近400万，荣获
              2016重庆市“互联网+”试点项目。
            </p>
            <span>暖青汇</span>
          </div>
        </div>
        <div class="case-li">
          <img src="../../assets/img/case-3.png" alt="" />
          <div>
            <p>
              利用微信平台树立良好的交巡警形象，提供交巡警服务，传播交管政策法规，减少办事环节，提高公众的参与度，优化政府信息资源配置，完善政府与公众的沟通渠道，构建警民关系管理系统、实时沟通，扩展服务范围，创新电子政务新模式。
            </p>
            <span>重庆交巡警</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 优质客户 -->
    <div class="client">
      <div class="client-title">
        <h3>更多优质客户</h3>
      </div>
      <div class="client-list">
        <img :src="item" alt="" v-for="(item, index) in clientList" :key="index" />
      </div>
    </div>
    <!-- 公司地址 -->
    <div class="address">
      <div class="client-title">
        <h3>公司地址</h3>
      </div>
      <div class="">
        <Map :height="height"></Map>
      </div>
    </div>
    <!-- 回到顶部 -->
    <img
      src="../../assets/icon/return-top.png"
      alt=""
      class="scroll-top"
      @click="scrollTop"
      v-if="returnShow"
    />
  </div>
</template>

<script>
import netWork from "@/api/netWork";
import Map from "../../components/map/index.vue";
export default {
  data() {
    return {
      clientList: [
        require("../../assets/img/client-1.png"),
        require("../../assets/img/client-2.png"),
        require("../../assets/img/client-3.png"),
        require("../../assets/img/client-4.png"),
        require("../../assets/img/client-5.png"),
        require("../../assets/img/client-6.png"),
        require("../../assets/img/client-7.png"),
        require("../../assets/img/client-8.png"),
        require("../../assets/img/client-9.png"),
        require("../../assets/img/client-10.png"),
      ],
      idx: 1,
      height: "15rem",
      screenHeight: "", //屏幕高度
      returnShow: false, //是否显示返回顶部按钮
    };
  },
  components: {
    Map,
  },
  created() {
    let i = this.$route.query.i;
    if (i) {
      this.idx = i ? i : 1;
      this.navChange(i);
    }
  },
  mounted() {
    this.$nextTick(function () {
      let _this = this;
      _this.screenHeight = window.screen.height;
      window.addEventListener("scroll", this.onScroll);
    });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    navChange(i) {
      if (this.idx != i) {
        this.idx = i;
      }
      let anchorName = "";
      if (i == 1) {
        anchorName = "introduce";
      } else if (i == 2) {
        anchorName = "product";
      } else if (i == 3) {
        anchorName = "case";
      }
      this.$nextTick((_) => {
        let anchorElement = document.getElementById(anchorName);
        /*如果对应id的锚点存在，就跳转到锚点*/
        if (anchorElement) {
          anchorElement.scrollIntoView();
        }
      });
    },
    scrollTop() {
      window.scroll({
        top: 0,
        behavior: "smooth",
      });
    },
    onScroll(e) {
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (this.scroll > this.screenHeight) {
        this.returnShow = true;
      } else {
        this.returnShow = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  background: #fbfbfb;
}
.home-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #000;
  padding: 0 1.2rem;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10;
  box-sizing: border-box;
  .logo {
    > img {
      width: 3.98rem;
      height: 1.2rem;
    }
  }
  nav {
    display: flex;
    align-items: center;
    color: #fff;
    font-size: 0.8rem;
    padding: 0.8rem 0;
    > a {
      padding: 0.2rem 0;
      margin-right: 3.95rem;
      color: #fff;
      line-height: 1.2rem;
      &.active {
        border-bottom: 1px solid #fff;
      }
      &:last-child {
        margin-right: 0;
      }
    }
    > div {
      line-height: 1.2rem;
      cursor: pointer;
      &.active {
        border-bottom: 1px solid #fff;
      }
    }
  }
}

.banner {
  width: 100%;
  height: 30rem;
  position: relative;
  .banner-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
  .banner-item {
    position: relative;
    z-index: 5;
    width: 18.1rem;
    height: 100%;
    padding-left: 6.35rem;
    .el-carousel__container {
      width: 100%;
    }
    .banner-text {
      color: #fff;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      > div:nth-child(1) {
        font-size: 2.4rem;
        line-height: 2.81rem;
        font-weight: 900;
      }
      > div:nth-child(2) {
        font-size: 0.8rem;
        line-height: 1.2rem;
        margin-top: 0.6rem;
      }
    }
  }
}
.introduce {
  .introduce-title {
    padding-top: 4rem;
    padding-bottom: 2rem;
    text-align: center;
    color: #1d2129;
    line-height: 2.2rem;
    font-size: 1.8rem;
    font-weight: 600;
  }
  .introduce-content {
    position: relative;
    height: 19.5rem;
    > img {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }
    .introduce-text {
      height: 100%;
      position: relative;
      z-index: 5;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 0 6.7rem 0 2rem;
      > div:nth-child(1) {
        font-size: 1.8rem;
        color: #1d2129;
        font-weight: 600;
        line-height: 2.2rem;
      }
      > div:nth-child(2) {
        font-size: 0.9rem;
        color: var(--main-color);
        line-height: 1.3rem;
        text-align: justify;
        margin: 1.2rem 0 0.8rem;
      }
      > div:nth-child(3) {
        font-size: 0.9rem;
        color: var(--main-color);
        line-height: 1.3rem;
        text-align: justify;
      }
    }
  }
}
.product {
  .product-title {
    padding-top: 4rem;
    padding-bottom: 2rem;
    text-align: center;
    color: #1d2129;
    line-height: 2.2rem;
    font-size: 1.8rem;
    font-weight: 600;
  }
  .product-content {
    background: #eef4fa;
    padding: 2rem;
    .product-item {
      display: flex;
      justify-content: space-between;
      color: #ffffff;
      .product-item-index {
        &:nth-child(1) {
          width: 66%;
        }
        width: 32%;
        height: 14.7rem;
        position: relative;
        > img {
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
          border-radius: 0.4rem;
        }
        .product-item-text {
          position: relative;
          z-index: 5;
          font-size: 1.8rem;
          line-height: 2.2rem;
          margin-left: 1.2rem;
          margin-top: 4.5rem;
        }
        .product-item-tags {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          box-sizing: border-box;
          padding-left: 1.2rem;
          background: rgba(0, 0, 0, 0.21);
          display: flex;
          border-radius: 0.4rem;
          > span {
            padding: 0.25rem 0;
            line-height: 2.2rem;
            font-size: 1.2rem;
            margin-right: 1.6rem;
            &:last-child {
              margin-right: 0;
            }
          }
        }
      }
    }
    .product-item2 {
      display: flex;
      justify-content: space-between;
      color: #ffffff;
      margin-top: 1.5rem;
      .product-item-index {
        width: 32%;
        height: 14.7rem;
        position: relative;
        > img {
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
          border-radius: 0.4rem;
        }
        .product-item-text {
          position: relative;
          z-index: 5;
          font-size: 1.8rem;
          line-height: 2.2rem;
          margin-left: 1.2rem;
          margin-top: 4.5rem;
        }
        .product-item-tags {
          position: absolute;
          left: 0;
          bottom: 0;
          z-index: 5;
          width: 100%;
          border-radius: 0.4rem;
          box-sizing: border-box;
          padding-left: 1.2rem;
          background: rgba(0, 0, 0, 0.21);
          display: flex;
          > span {
            padding: 0.25rem 0;
            line-height: 2.2rem;
            font-size: 1.2rem;
            margin-right: 1.6rem;
            &:last-child {
              margin-right: 0;
            }
          }
        }
      }
    }
  }
}
.case {
  background: #fbfbfb;
  .case-title {
    padding-top: 4rem;
    padding-bottom: 2rem;
    text-align: center;
    color: #1d2129;
    line-height: 2.2rem;
    font-size: 1.8rem;
    font-weight: 600;
  }
  .case-list {
    display: flex;
    justify-content: space-between;
    padding: 2rem;
    .case-li {
      width: 32%;
      border-radius: 0.4rem 0.4rem 0.4rem 0.4rem;
      box-shadow: 0rem 0.2rem 1.6rem -0.3rem rgba(151, 185, 255, 0.24);
      background: #ffffff;
      height: 24.5rem;
      position: relative;
      > img {
        width: 100%;
        height: 12.3rem;
      }
      > div {
        position: absolute;
        bottom: 0;
        left: 0;
        height: 13.7rem;
        width: 100%;
        border-radius: 0.45rem 0.45rem 0.45rem 0.45rem;
        z-index: 5;
        font-size: 0.7rem;
        background: #ffffff;
        color: var(--main-color);
        box-sizing: border-box;
        padding: 1.2rem 1.6rem;
        > p {
          line-height: 1.1rem;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 8;
          -webkit-box-orient: vertical;
        }
        > span {
          position: absolute;
          bottom: 1.6rem;
          right: 1.6rem;
          font-size: 0.7rem;
          color: #000000;
          line-height: 1.1rem;
          padding-left: 2.8rem;
          &::before {
            content: "";
            height: 2px;
            width: 2.4rem;
            background: rgba(0, 0, 0, 0.15);
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
          }
        }
      }
    }
  }
}
.client,
.address {
  background: #fbfbfb;
  .client-title {
    padding: 4rem 2.8rem 2rem;
    text-align: center;
    > h3 {
      position: relative;
      font-weight: 400;
      color: #1d2129;
      line-height: 1.3rem;
      font-size: 1.3rem;
      &::before {
        content: "";
        width: 20rem;
        height: 2px;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        background: linear-gradient(-45deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0));
      }
      &::after {
        content: "";
        width: 20rem;
        height: 2px;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        background: linear-gradient(45deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0));
      }
    }
  }
  .client-list {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 0.8rem 2rem 0;
    > img {
      width: 18%;
      height: 2.7rem;
      margin-right: 1.2rem;
      &:nth-child(5n) {
        margin-right: 0;
      }
    }
  }
}
.address {
  margin-bottom: 4rem;
}
.scroll-top {
  position: fixed;
  z-index: 110;
  right: 2rem;
  bottom: 2rem;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  cursor: pointer;
}
</style>
<!-- <style>
	.el-carousel__indicators--horizontal{
		left:0;
		transform: translateX(0);
	}
</style> -->
